<!--<img [src]="getUrl()" class="img-fluid w-100" [alt]="asset().displayName" />-->
<!--<div [innerHtml]="asset() | assetBlob: 'text' | async | safeHtml" class="img"></div>-->
<!--<object type="image/svg+xml" [data]="getUrl() | safeUrl" class="w-100"></object>-->
@switch (mode()) {
  @case ('thumbnail') {
    <i class="fa fa-image"></i>
  }
  @case ('view') {
    <img [src]="getUrl()" class="img-fluid w-100" [alt]="asset().displayName"/>
  }
  @case ('details') {
    <section>
      @if (asset().defIds.length) {
        <h4>Def IDs</h4>
        <pre>{{ asset().defIds.join('\n') }}</pre>
      }
      <h4>Storage Path</h4>
      <pre>{{ asset().storagePath }}</pre>
    </section>
  }
}
